import './styles.css';
import sdk from './sdk';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

export default sdk;
